import * as yup from "yup";
import { ERRORS } from "../constants/errors";

export const addFaqValidation = yup.object().shape({
    question: yup.string().required(ERRORS.QUESTION_REQUIRED),
    answer: yup.string().required(ERRORS.ANSWER_REQUIRED),
});

export const updateFaqValidation = yup.object().shape({
    question: yup.string().required(ERRORS.QUESTION_REQUIRED),
    answer: yup.string().required(ERRORS.ANSWER_REQUIRED),
});

